import { padStart, isNil, parseInt } from 'lodash';

export default function formatTime(value) {
  if (isNil(value)) return '';
  const min = parseInt(value / 60, 10);
  const sec = padStart(value % 60, 2, 0);

  return `${min}:${sec}`;
}
